import {base58_to_binary, binary_to_base58} from 'base58-js'
import { sha256 } from 'js-sha256'
import {Buffer} from 'buffer'

function invalidAddress(address){
  if(/^0x[0-9a-fA-F]{40}/.test(address) != true) throw 'invalid address'
}
export const base58en = hex => {
  invalidAddress(hex)
  hex = hex.replace('0x', '41')
  const checksum = checksumAddr(hex)
  const res = binary_to_base58(Buffer.from(hex + checksum, 'hex'))
  if(res.substr(0, 1) != 'T')
    throw 'invalid address'
  return res
}
export const base58de = addr => {
  const hex = Buffer.from(base58_to_binary(addr)).toString('hex')
  let address = hex.substr(0, hex.length - 8)
  const checksum = checksumAddr(address)
  
  if(checksum != hex.substr(hex.length - 8)) 
    throw 'invalid tron address'
  if(address.substr(0, 2) != '41') 
    throw 'invalid tron address'
  address = '0x' + address.substr(2)
  invalidAddress(address)
  return address
}
function checksumAddr(hex){
  return sha256(
    Buffer.from(
      sha256(
        Buffer.from(hex, 'hex')
      ), 
      'hex'
    )
  ).substr(0, 8)
}

export const triggerConstantContract = (contract, method, args) => {
  if(contract.substr(0, 1) == 'T') contract = base58_to_binary(contract)
  return fetch(
    'https://api.trongrid.io/walletsolidity/triggerconstantcontract',
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        owner_address: '410000000000000000000000000000000000000000',
        contract_address: contract,
        function_selector: method,
        parameter: args,
      })
    }
  ).then(r => r.json())
}
window.base58de = base58de
window.base58en = base58en